module.exports = __webpack_public_path__ + "coin_OTHER.png?24bf1c74c33a5d4c7d8a360045f8635e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_OTHER.png
// module id = 1112
// module chunks = 2